import { Component, Input, forwardRef } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { SelectOption } from 'src/app/shared/models/select-option.model';


@Component({
  selector: 'app-select-input',
  templateUrl: './select-input.component.html',
  styleUrls: ['./select-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SelectInputComponent),
      multi: true,
    },
  ],
})

export class SelectInputComponent implements ControlValueAccessor{

  selectFormControl=new FormControl('');

  @Input() options!:SelectOption[];
  @Input() key:string = 'value';
  @Input() placeholder:string= '';
  @Input() label:string='';
  @Input() bgClass:string='bg-white';
  @Input() hasError:boolean = false;
  @Input() readOnly:boolean = false;
  @Input() multiple:boolean = false;
  @Input() required:boolean = false;

  propagateChange = (_: any) => {};
  touchChange = (_: any) => {};


  onSelectionChange(){
    this.propagateChange(this.selectFormControl.value);
  }

  writeValue(obj: any): void {
    if (!!obj){
      this.selectFormControl.setValue(obj);
      return;
      }
      this.selectFormControl.setValue('')
  }

  registerOnChange(fn: any): void {
    this.propagateChange=fn;
  }

  registerOnTouched(fn: any): void {
    this.touchChange=fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    //throw new Error('Method not implemented.');
  }

}

